export default __webpack_public_path__ + "static/media/request_arknote@2x.3849f199.png";